import { chain } from 'lodash';

import { registerDecorator, ValidationOptions } from 'class-validator';

export function MenuLabelIsUnique(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'MenuLabelIsUnique',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(currentValue: string) {
          const duplicates = chain(currentValue)
            .groupBy('label')
            .pickBy(x => x.length > 1)
            .value();
          return !Object.keys(duplicates).length;
        },

        defaultMessage() {
          return 'Duplicate label. Please use a unique label.';
        },
      },
    });
  };
}
